export default __webpack_public_path__ + "static/media/file.11bf8ec5.png";